import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { User, LogOut, Settings } from 'lucide-react';

const UserProfile = ({ onShowUserPanel }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, logout } = useAuth();
  
  if (!user) return null;
  
  const handleLogout = () => {
    logout();
    window.location.href = '/login';
  };
  
  const handleProfileClick = () => {
    setIsOpen(false);
    onShowUserPanel(true);
  };
  
  
  return (
    <div className="relative">
      <button 
        className="flex items-center text-white focus:outline-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="w-8 h-8 bg-indigo-700 rounded-full flex items-center justify-center mr-2">
          <User className="h-4 w-4" />
        </div>
        <span>{user.username}</span>
      </button>
      
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10">
          <div className="px-4 py-2 text-sm text-gray-700 border-b">
            <div className="font-medium">{user.username}</div>
            <div className="text-gray-500">
              {user.role === 'admin' ? 'Administrator' : 
               user.role === 'agent' ? 'Agent' : 
               user.role === 'jk_manager' ? 'JK Manager' : 
               user.role === 'user' ? 'Benutzer' : user.role}
            </div>
          </div>
          
          <button 
            className="block w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100 flex items-center"
            onClick={handleProfileClick}
          >
            <Settings className="h-4 w-4 mr-2" />
            Benutzerprofil
          </button>
          
          <button 
            className="w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100 flex items-center"
            onClick={handleLogout}
          >
            <LogOut className="h-4 w-4 mr-2" />
            Abmelden
          </button>
        </div>
      )}
    </div>
  );
};

export default UserProfile;